<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header *ngIf="contentHeader" [contentHeader]="contentHeader"></app-content-header>
        <core-card [actions]="[]">
            <div class="card-title w-100">
                <div class="row" *ngIf="_utilService.isDesktop">
                    <div class="col-lg-7 col-12" [ngClass.md]="'mb-1'">
                        <div class="d-flex">
                            <div class="mr-1" *ngIf="!isViewFolder">
                                <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control w-fit" [(ngModel)]="searchKeyword"/>
                            </div>
                            <div class="flex-basis-30 font-small-4 font-weight-normal mr-1" *ngIf="!isViewFolder">
                                <ng-select  ngClass.sm="mx-auto mt-1" [ngClass.xl]="'ml-1'" [(ngModel)]="selectedCategory" id="category" [searchable]="true"
                                            [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                                    <ng-option disabled="disabled" value="all">{{'CATEGORY' | translate}}</ng-option>
                                    <ng-option value="all">{{"ALL" | translate}}</ng-option>
                                    <ng-option *ngFor="let cat of categories"
                                               [value]="cat.name">{{cat.parent_id ? '&#8211;' : ''}} {{cat.name}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="flex-basis-30 font-small-4 font-weight-normal">
                                <button class="btn btn-outline-primary" (click)="changeView()">{{!isViewFolder ? ("VIEW_FOLDER" | translate)  : ("VIEW_TABLE") | translate}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-12">
                        <div class="d-flex" [ngClass.xl]="'justify-content-end'">
                            <div class="d-inline-block mr-2" *ngIf="!isViewFolder">
                                <label class="d-flex align-items-center mb-0">{{"SHOW" | translate}}
                                    <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </label>
                            </div>
                            <button [routerLink]="'/dashboard/documents-send'"
                                    class="btn btn-outline-primary" ngClass.lg="d-flex justify-content-end"
                                    ngClass.sm="d-flex justify-content-center mx-auto mt-1" *ngIf="_authenticationService.hasCapability('create_document')">{{"SEND_DOCUMENT" | translate}}
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="_utilService.isMobile || _utilService.isTablet" class="row">
                    <div class="col-12" *ngIf="!isViewFolder">
                        <input type="search" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword"/>
                    </div>
                    <div class="col-12 my-1" *ngIf="!isViewFolder">
                        <ng-select [(ngModel)]="selectedCategory" class="font-small-4 font-weight-normal">
                            <ng-option disabled="disabled" value="all">{{'CATEGORY' | translate}}</ng-option>
                            <ng-option value="all">{{"ALL" | translate}}</ng-option>
                            <ng-option *ngFor="let cat of categories"
                                       [value]="cat.name">{{cat.parent_id ? '&#8211;' : ''}} {{cat.name}}</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-12 mt-1 d-flex justify-content-center mx-auto">
                        <button class="btn btn-outline-primary mr-1" (click)="changeView()">{{!isViewFolder ? ("VIEW_FOLDER" | translate)  : ("VIEW_TABLE") | translate}}</button>
                        <button [routerLink]="'/dashboard/documents-send'" *ngIf="_authenticationService.hasCapability('create_document')"
                                class="btn btn-outline-primary">{{"SEND_DOCUMENT" | translate}}
                        </button>
                    </div>
                </div>
            </div>
            <!--Tree view like mac finder-->
            <div class="card-body" *ngIf="isViewFolder">
                <div class="row">
                    <!--Categories Parent-->
                    <div class="col-12 mt-075" *ngFor="let cat of categoriesTreeView">
                        <div class="d-flex align-items-center cursor-pointer" (click)="showChildCategory(cat)" *ngIf="!cat.parent_id"> <i  class="text-primary mr-1 cursor-pointer" [data-feather]="'folder'" size="19"></i>{{cat.name}}</div>
                        <!--Categories Child that have others folder-->
                        <div class="ml-1 mt-075" *ngIf="cat.showChild && cat.child">
                            <div class="mt-075" *ngFor="let catChild of cat.child">
                                <div class="d-flex align-items-center cursor-pointer" (click)="showFileListOfCategory(catChild)"><i class="text-primary mr-1 cursor-pointer" [data-feather]="'folder'" size="19"></i>{{catChild.name}}</div>
                                <div *ngFor="let file of catChild.fileList">
                                    <div class="mt-075 cursor-pointer d-flex align-items-center justify-content-between" *ngIf="catChild.fileList && catChild.showFile">
                                        <div (click)="goToDocument(file)" class="ml-1" >
                                            <img class="mr-1" src="assets/images/icons/pdf.png" width="14" height="19" *ngIf="!file.haveNotChild" alt="icon-pdf"/>
                                            {{file.title}}</div>
                                        <small class="text-muted" *ngIf="file.send_date">{{_utilService.formatDate(file.send_date)}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Child of parents the have directly file inside-->
                        <div class="ml-1 mt-075" *ngIf="cat.showChild && !cat.child">
                            <div *ngFor="let file of cat.fileList">
                                <div class="mt-075 cursor-pointer d-flex align-items-center justify-content-between" *ngIf="cat.fileList && cat.showChild">
                                    <span (click)="goToDocument(file)" class="ml-1">
                                        <img class="mr-1" src="assets/images/icons/pdf.png" width="14" height="19" *ngIf="!file.haveNotChild" alt="icon-pdf"/>
                                        {{file.title}}</span>
                                    <small class="text-muted" *ngIf="file.send_date">{{_utilService.formatDate(file.send_date)}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--desktop-->
            <div class="card-body p-0" *ngIf="_utilService.isDesktop && !isViewFolder">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [scrollbarH]="config.scrollbarH" [rowHeight]="config.rowHeight" [limit]="tableLimit"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}" [footerHeight]="config.footerHeight"
                               [rows]="documentList()">
                    <ngx-datatable-column name="{{'DOCUMENT' | translate}}" prop='title'
                                          sortable="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span class="line-height-2">{{row.title}}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'CATEGORY' | translate}}" prop="category_name"
                                          [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span class="line-height-1">{{row.category_name}}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'DATE' | translate}}" prop="send_date"
                                          [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span class="line-height-1">{{_utilService.formatDate(row.send_date, 'DD/MM/YY')}}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'ACTIONS' | translate}}" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="d-flex align-items-center">
                                <button class="btn btn-outline-secondary btn-sm" (click)="goToDocument(row)">{{"VIEW" | translate}}</button>
                                <button class="bg-transparent border-0 text-secondary ml-025 pr-1" *ngIf="row.send_date > tomorrow && _authenticationService.hasCapability('edit_document')"
                                        [routerLink]="'/dashboard/document-edit/'+row.id">
                                    <i [data-feather]="'edit-2'" size="19"></i>
                                </button>
                                <button (click)="deleteDocument(row)" class="bg-transparent border-0 text-danger remove-item"
                                        *ngIf="row.send_date > tomorrow && _authenticationService.hasCapability('delete_document')">
                                    <i [data-feather]="'trash-2'" size="19"></i>
                                </button>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <!--mobile & tablet-->
            <div class="card-body p-0" *ngIf="(_utilService.isMobile || _utilService.isTablet) && !isViewFolder">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [scrollbarH]="false" [rowHeight]="_utilService.isMobile ? 170 : 130" [limit]="tableLimit"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}" [footerHeight]="config.footerHeight"
                               [rows]="documentList()">
                    <ngx-datatable-column name="{{'DOCUMENT' | translate}}" prop='title' sortable="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="row list-item-mobile">
                                <div class="col-8" [ngClass.md]="'pl-0'">
                                    <div>
                                        <span class="line-height-1">{{row.title}}</span>
                                    </div>
                                    <div>
                                        <span class="line-height-1">{{row.category_name}}</span>
                                    </div>
                                    <div>
                                        <span class="line-height-1">{{_utilService.formatDate(row.send_date, 'DD/MM/YY')}}</span>
                                    </div>
                                </div>
                                <div class="col-4 d-flex align-items-center justify-content-center pl-0">
                                    <div>
                                        <button class="btn btn-outline-secondary btn-sm" (click)="goToDocument(row)">{{"VIEW" | translate}}</button>
                                        <button class="bg-transparent border-0 text-secondary ml-025 pr-1" *ngIf="row.send_date > tomorrow && _authenticationService.hasCapability('edit_document')"
                                                [routerLink]="'/dashboard/document-edit/'+row.id">
                                            <i [data-feather]="'edit-2'" size="19"></i>
                                        </button>
                                        <button (click)="deleteDocument(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="row.send_date > tomorrow && _authenticationService.hasCapability('delete_document')">
                                            <i [data-feather]="'trash-2'" size="19"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </core-card>
    </div>
</div>
